import logo from "./BamfordsLogo.svg";
import logoLight from "./BamfordsLogoLight.svg";
import incoming from "./IncomingCall.svg";
import logoWhite from "./BamfordsLogoWhite.svg";
import star from "./star.png";

export const logoSVG = logo;
export const logoLightSVG = logoLight;
export const logoWhiteSVG = logoWhite;
export const incomingSVG = incoming;
export const starPNG = star;